import {
  CancellationFlowStatus,
  getCancellationFlowStatusClass,
  getCancellationFlowStatusLabel,
} from './cancellation-flow-status.enum';

/** A timeline row that edited the cancellation's fields rather than moving its status. */
export const CANCELLATION_HISTORY_UPDATED = 'UPDATED';

/**
 * What a row of a cancellation's timeline records: a period spent in one of
 * the flow's statuses, or an `UPDATED` edit of its fields — instantaneous, and
 * never the flow's own status.
 */
export type CancellationFlowHistoryStatus =
  | CancellationFlowStatus
  | typeof CANCELLATION_HISTORY_UPDATED;

export const getCancellationFlowHistoryLabel = (
  status: CancellationFlowHistoryStatus
): string =>
  status === CANCELLATION_HISTORY_UPDATED
    ? $localize`Modification`
    : getCancellationFlowStatusLabel(status);

export const getCancellationFlowHistoryStatusClass = (
  status: CancellationFlowHistoryStatus
): string =>
  status === CANCELLATION_HISTORY_UPDATED
    ? 'gray'
    : getCancellationFlowStatusClass(status);
